module.exports = __webpack_public_path__ + "static/media/logo.abb48ff5.png";